module.exports = __webpack_public_path__ + "img/logo.b050e699.png";